//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { LookupModel } from './../../common/models/LookupModel';
  
export class SubmittingEntityIdentifierModel {
    static readonly $typeName = 'SubmittingEntityIdentifierModel';
    public key: string;
    public identifier: string;
    public identifierType: LookupModel;
}



// WEBPACK FOOTER //
// ./src/app/submission/models/SubmittingEntityIdentifierModel.ts